import { Heart } from "lucide-react";

const TelcaVoIPBadge = ({ className = "" }) => {
  return (
    <a
      href="https://telcavoip.ai"
      target="_blank"
      rel="noopener noreferrer"
      className={`hidden md:inline-flex fixed bottom-4 right-4 z-50 items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary/10 hover:bg-primary/20 text-primary text-xs font-medium transition-colors ${className}`}
      data-testid="telcavoip-badge"
    >
      Made With <Heart className="w-3 h-3 fill-red-500 text-red-500" /> By TelcaVoIP AI
    </a>
  );
};

export default TelcaVoIPBadge;
